import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import API_ENDPOINTS from '../../../helperFunction/Constant';
import ApiHelper from '../../../helperFunction/ApiHelper';
import Layout from '../../common/Layout';

const UserAttempts = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [enrolledData, setEnrolledData] = useState([])
    const navigate = useNavigate()

    const { quizId, id } = useParams()

    useEffect(() => {
        getQuizData()
    }, [])

    const getQuizData = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_USERS_ATTEMPTS}/${id}?quizId=${quizId}`).then((res) => {
            if (res.status === 200) {
                setEnrolledData(res?.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.thumbnail || rowData?.quizName ? (
                <div style={{ display: "flex", alignItems: "center", color: 'blue', gap: "10px", cursor:'pointer' }} onClick={() => {navigate(`/quiz/${quizId}/enrolled-users/${id}/results/${rowData.attemptId}`)}} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.thumbnail}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.quizName}
                </div>
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.status === 'submitted' ? 'bg-success' : 'bg-danger'} `}>
                {rowData.status}
            </span>
        );
    };
    
    const zonNameBodyTemplate = (rowData) => {
        return (
            <p style={{color: (rowData?.type) === 'red' && '#DC2626' || (rowData?.type) === 'yellow' && '#D97706' || (rowData?.type) === 'green' && '#059669',}}>
                {rowData.zoneName}
            </p>
        );
    };
    
    const scoreBodyTemplate = (rowData) => {
        return (
            <span className='badge text-bg-light' style={{fontSize: '15px', color: (rowData?.type) === 'red' && '#DC2626' || (rowData?.type) === 'yellow' && '#D97706' || (rowData?.type) === 'green' && '#059669' || (rowData?.type) === null && 'black',}}>
                {rowData.totalScore}
            </span>
        );
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <>
        <Toast ref={toast} />
        <ConfirmDialog />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                            <p class="breadcrumb-item pageHeader active mb-0" aria-current="page" onClick={() => navigate(`/quiz`)}> Quiz </p><p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate(`/quiz/${quizId}/enrolled-users`)}> Enrolled Users </p> / <b className='mx-2'> {enrolledData?.userName} </b>
                            </span>
                        </h4>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={enrolledData?.data} tableStyle={{ minWidth: '50rem' }} >
                                        <Column body={serialNoTemplate} header='S.NO' />
                                        <Column sortable header='Name' body={imageBodyTemplate} field='quizName' /> 
                                        <Column sortable header='Start time' field='startedAt' body={(rowData) => {
                                                const date = new Date(rowData.startedAt);
                                                return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true, });
                                            }} />
                                        <Column sortable header='Status' body={statusBodyTemplate} />
                                        <Column sortable header='Total Score' body={scoreBodyTemplate} field='totalScore' />
                                        <Column sortable header='Result' body={zonNameBodyTemplate} field='zoneName' />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default UserAttempts
